import React from "react";
import * as FormStyles from "../../style/FormStyles";
import logo from "../../../images/landing/navigation/avatarneo.png";
import LoadingWheel from "../LoadingWheel";

export function ForgotPasswordRequestForm(props) {
    return (
        <FormStyles.FormDiv>
            <FormStyles.Form onSubmit={props.handleSubmit}>
                {props.loading ? (
                    <LoadingWheel />
                ) : (
                    <>
                        <FormStyles.FormLogoLink to={"/"}>
                            <img src={logo} />
                        </FormStyles.FormLogoLink>
                        <FormStyles.FormTitleText>Find your account</FormStyles.FormTitleText>
                        <FormStyles.FormDescriptionText>
                            Please enter your email address.
                        </FormStyles.FormDescriptionText>
                        {props.errorMsg && (
                            <FormStyles.FormErrorDiv>&#9888; {props.errorMsg}</FormStyles.FormErrorDiv>
                        )}
                        <FormStyles.FormInputDiv>
                            <FormStyles.FormInput name="email" autocomplete="email" required />
                            <FormStyles.FormLabel>Email</FormStyles.FormLabel>
                        </FormStyles.FormInputDiv>
                        <FormStyles.FormSpacerDiv />
                        <FormStyles.FormButton type="submit">Next</FormStyles.FormButton>
                    </>
                )}
            </FormStyles.Form>
        </FormStyles.FormDiv>
    );
}

export function ForgotPasswordVerifyForm(props) {
    return (
        <FormStyles.FormDiv>
            <FormStyles.Form onSubmit={props.handleSubmit}>
                {props.loading ? (
                    <LoadingWheel />
                ) : (
                    <>
                        <FormStyles.FormLogoLink to={"/"}>
                            <img src={logo} />
                        </FormStyles.FormLogoLink>
                        <FormStyles.FormTitleText>Verify your email</FormStyles.FormTitleText>
                        <FormStyles.FormDescriptionText>
                            If we have an account matching your email address, you will receive an email with a password reset code. The code will expire in about 10 minutes.
                        </FormStyles.FormDescriptionText>
                        {props.errorMsg && (
                            <FormStyles.FormErrorDiv>&#9888; {props.errorMsg}</FormStyles.FormErrorDiv>
                        )}
                        <FormStyles.FormInputDiv>
                            <FormStyles.FormInput name="token" autocomplete="one-time-code" required />
                            <FormStyles.FormLabel>Verification Code</FormStyles.FormLabel>
                        </FormStyles.FormInputDiv>
                        <FormStyles.FormHelperText>
                            <a href='/account/forgot-password'>Re-enter email address</a>
                        </FormStyles.FormHelperText>
                        <FormStyles.FormSpacerDiv />
                        <FormStyles.FormButton type="submit">Verify</FormStyles.FormButton>
                    </>
                )}
            </FormStyles.Form>
        </FormStyles.FormDiv>
    );
}
